/* Lightweight GA4 helper for SPA routing and events */

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.async = true;
    s.src = src;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

let initialized = false;
let measurementId = undefined;

export async function initAnalytics(id) {
  if (!id || initialized) return;
  measurementId = id;
  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);} // eslint-disable-line no-inner-declarations
  window.gtag = gtag;
  await loadScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`);
  gtag('js', new Date());
  gtag('config', id, { send_page_view: false });
  initialized = true;
}

export function trackPageview(path, title) {
  if (!initialized || !measurementId || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_title: title || document.title,
    page_location: window.location.href,
    page_path: path
  });
}

export function trackEvent(name, params = {}) {
  if (!initialized || !measurementId || !window.gtag) return;
  window.gtag('event', name, params);
}


